export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/unboxing_videos.7736eb0.svg";